import {} from "features/relatorios/typings";
import { formatMoney } from "infra/helpers/number";
import { useMemo } from "react";
import { PDFTableColumn } from "components/PDF/Table";
import { View, Text } from "@react-pdf/renderer";
import colors from "core/resources/theme/colors";
import { TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow } from "./../../../../RelatorioDemonstrativo/helper/util";

const commonStyles = () => ({
  color: colors.black ,
  fontSize: 7,
});

const CommonText = ({
  children,
}: {
  itemHasChildren: boolean;
  children: React.ReactNode;
}) => (
  <Text
    style={{
      ...commonStyles(),
    }}
  >
    {children}
  </Text>
);

function useRelatorioDemonstrativoReceitaDespesaPdfColumns(
  title?: string,
  ano?: string
): PDFTableColumn<TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<TabelaCategoriasRelatorioDemonstrativoReceitaDespesaAnualRow>[] =
      [];

    columns.push({
      title: title || "",
      flexGrow: 3.5,
      render: (original) => {
        return (
          <View>
            <Text
              style={{
                fontWeight:
                  original.totalRow ||
                  !Number.isFinite(original.valor) ||
                  original.hasChildren
                    ? "medium"
                    : undefined,
                paddingLeft: original.nivel * 5,
                ...commonStyles(),
              }}
            >
              {original.breadcrumb} {original.nome}
            </Text>
          </View>
        );
      },
    });

    columns.push({
      title: `Jan/${ano}`,
      flexGrow: 1,
      textAlign: "right",
      render: (original) => {
        return (
          <View>
            <CommonText itemHasChildren={original.hasChildren}>
              {Number.isFinite(original["mes-0"])
                ? formatMoney(original["mes-0"], true)
                : ""}
            </CommonText>
          </View>
        );
      },
    });

    columns.push({
      title: `Fev/${ano}`,
      flexGrow: 1,
      textAlign: "right",
      render: (original) => {
        return (
          <View>
            <CommonText itemHasChildren={original.hasChildren}>
              {Number.isFinite(original["mes-1"])
                ? formatMoney(original["mes-1"], true)
                : ""}
            </CommonText>
          </View>
        );
      },
    });

    columns.push({
      title: `Mar/${ano}`,
      flexGrow: 1,
      textAlign: "right",
      render: (original) => {
        return (
          <View>
            <CommonText itemHasChildren={original.hasChildren}>
              {Number.isFinite(original["mes-2"])
                ? formatMoney(original["mes-2"], true)
                : ""}
            </CommonText>
          </View>
        );
      },
    });

    columns.push({
      title: `Abr/${ano}`,
      flexGrow: 1,
      textAlign: "right",
      render: (original) => {
        return (
          <View>
            <CommonText itemHasChildren={original.hasChildren}>
              {Number.isFinite(original["mes-3"])
                ? formatMoney(original["mes-3"], true)
                : ""}
            </CommonText>
          </View>
        );
      },
    });

    columns.push({
      title: `Mai/${ano}`,
      flexGrow: 1,
      textAlign: "right",
      render: (original) => {
        return (
          <View>
            <CommonText itemHasChildren={original.hasChildren}>
              {Number.isFinite(original["mes-4"])
                ? formatMoney(original["mes-4"], true)
                : ""}
            </CommonText>
          </View>
        );
      },
    });

    columns.push({
      title: `Jun/${ano}`,
      flexGrow: 1,
      textAlign: "right",
      render: (original) => {
        return (
          <View>
            <CommonText itemHasChildren={original.hasChildren}>
              {Number.isFinite(original["mes-5"])
                ? formatMoney(original["mes-5"], true)
                : ""}
            </CommonText>
          </View>
        );
      },
    });
    columns.push({
      title: `Jul/${ano}`,
      flexGrow: 1,
      textAlign: "right",
      render: (original) => {
        return (
          <View>
            <CommonText itemHasChildren={original.hasChildren}>
              {Number.isFinite(original["mes-6"])
                ? formatMoney(original["mes-6"], true)
                : ""}
            </CommonText>
          </View>
        );
      },
    });
    columns.push({
      title: `Ago/${ano}`,
      flexGrow: 1,
      textAlign: "right",
      render: (original) => {
        return (
          <View>
            <CommonText itemHasChildren={original.hasChildren}>
              {Number.isFinite(original["mes-7"])
                ? formatMoney(original["mes-7"], true)
                : ""}
            </CommonText>
          </View>
        );
      },
    });
    columns.push({
      title: `Set/${ano}`,
      flexGrow: 1,
      textAlign: "right",
      render: (original) => {
        return (
          <View>
            <CommonText itemHasChildren={original.hasChildren}>
              {Number.isFinite(original["mes-8"])
                ? formatMoney(original["mes-8"], true)
                : ""}
            </CommonText>
          </View>
        );
      },
    });
    columns.push({
      title: `Out/${ano}`,
      flexGrow: 1,
      textAlign: "right",
      render: (original) => {
        return (
          <View>
            <CommonText itemHasChildren={original.hasChildren}>
              {Number.isFinite(original["mes-9"])
                ? formatMoney(original["mes-9"], true)
                : ""}
            </CommonText>
          </View>
        );
      },
    });
    columns.push({
      title: `Nov/${ano}`,
      flexGrow: 1,
      textAlign: "right",
      render: (original) => {
        return (
          <View>
            <CommonText itemHasChildren={original.hasChildren}>
              {Number.isFinite(original["mes-10"])
                ? formatMoney(original["mes-10"], true)
                : ""}
            </CommonText>
          </View>
        );
      },
    });
    columns.push({
      title: `Dez/${ano}`,
      flexGrow: 1,
      textAlign: "right",
      render: (original) => {
        return (
          <View>
            <CommonText itemHasChildren={original.hasChildren}>
              {Number.isFinite(original["mes-11"])
                ? formatMoney(original["mes-11"], true)
                : ""}
            </CommonText>
          </View>
        );
      },
    });

    columns.push({
      title: "Total",
      flexGrow: 1.25,
      textAlign: "right",
      render: (original) => (
        <View>
          <CommonText itemHasChildren={original.hasChildren}>
            {Number.isFinite(original.valor) ? formatMoney(original.valor) : ""}
          </CommonText>
        </View>
      ),
    });

    columns.push({
      title: "Média",
      flexGrow: 1.25,
      textAlign: "right",
      render: (original) => {
        const _media = original.totalRow ? original.mediaTotal : original.media;
        return (
          <View>
            <CommonText itemHasChildren={original.hasChildren}>
              {Number.isFinite(_media) ? formatMoney(_media) : ""}
            </CommonText>
          </View>
        );
      },
    });

    return columns;
  }, [ano, title]);
}

export default useRelatorioDemonstrativoReceitaDespesaPdfColumns;
